module.exports = __webpack_public_path__ + "static/media/loreal1.7471a9b6.jpg";